import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { StaffService } from '@app/core/staff';

@Component({
  selector: 'filter-sourcing-assignee',
  templateUrl: './filter-sourcing-assignee.component.html',
  styleUrls: ['./filter-sourcing-assignee.component.scss'],
})
export class FilterSourcingAssigneeComponent implements OnInit {
  constructor(public staffService :StaffService) {}

  @Input() value :number;
  @Input() label :string;
  @Output() changeSourcingAssignee :EventEmitter<number> =
    new EventEmitter<number>();

  goStaff :any[] = [];
  goTeam :any[] = [];

  ngOnInit() :void {
    this.staffService.staff$.subscribe((resp) => {
      this.goTeam = resp.filter((row :any) => {
        return row.role === 2;
      });
      this.goStaff = resp.filter((row :any) => {
        return row.role !== 2;
      });
    });
  }

  onChange() {
    this.changeSourcingAssignee.emit(this.value);
  }
}
